"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.wip.title': 'Trabajo en progreso',
    'socialMediaPlan.wip.description': 'Próximamente.',
};
